type InRange = {
    (value: number, start: number, end: number): boolean;
    (value: number, end: number): boolean;
};

export const inRange: InRange = (value: number, start: number, end?: number): boolean => {
    const s = end === undefined ? 0 : start;
    const e = end === undefined ? start : end;

    return value >= s && value < e;
};
